import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import priceWatchApi from '../../api/priceWatchApi';

/**
 * Cầu nối từ "Sản phẩm đã lưu" sang "Theo dõi giá" (bản web).
 *
 * "Đã lưu" là bookmark tĩnh, "Theo dõi giá" là cảnh báo chủ động — hai màn cố ý tách
 * riêng, nút 🔔 chỉ tạo đăng ký theo dõi chứ không gộp dữ liệu.
 *
 * Mốc `initialPrice` PHẢI là giá vừa làm mới (`priceUpdate.currentPrice`). Lấy nhầm giá
 * lúc lưu (có thể đã vài tháng) thì cron so sai ngay từ lần kiểm đầu: báo giảm giá khống,
 * hoặc im lặng khi giá đã thực sự giảm.
 *
 * Bản mobile tương ứng: `mobile/src/modules/trending/hooks/use-watch-from-saved.ts`.
 *
 * @param setProducts  để đổi icon ngay (optimistic) và trả lại khi request hỏng
 */
export default function useWatchFromSaved(setProducts) {
    const navigate = useNavigate();

    return useCallback(
        async (product) => {
            // Đang theo dõi ⇒ sang màn Theo dõi giá (nơi có nút gỡ), không gỡ tại chỗ để
            // tránh bấm nhầm làm mất cảnh báo đang chờ.
            if (product.isWatching) {
                navigate('/price-watch');
                return;
            }

            const basePrice = product.priceUpdate?.currentPrice ?? Number(product.productPrice);
            if (!basePrice) {
                toast.error('Chưa lấy được giá sản phẩm, vui lòng thử lại sau.');
                return;
            }

            const setWatching = (value) =>
                setProducts((prev) =>
                    prev.map((p) => (p.productId === product.productId ? { ...p, isWatching: value } : p))
                );

            setWatching(true); // optimistic
            try {
                await priceWatchApi.addWatch({
                    itemId: product.productId,
                    platform: 'shopee',
                    productName: product.productName,
                    imageUrl: product.productImage,
                    productLink: product.productLink,
                    currentPrice: basePrice,
                });
                toast.success('Đã thêm vào Theo dõi giá');
            } catch (err) {
                setWatching(false);
                // Hiện nguyên message server (vd "Tối đa 20 sản phẩm theo dõi") để user
                // hiểu vì sao không thêm được.
                toast.error(err?.response?.data?.message || 'Không thêm được, vui lòng thử lại.');
            }
        },
        [navigate, setProducts]
    );
}
